import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

export const generateAndDownloadExcel = async (filename, worksheetConfigs) => {
  const wb = new ExcelJS.Workbook();

  worksheetConfigs.forEach(wsConfig => {
    const { worksheetName, columnConfigs, data } = wsConfig;
    const ws = wb.addWorksheet(worksheetName);

    // Header row
    const headerRow = columnConfigs.map(({ headerText }) => headerText);
    ws.addRow(headerRow);

    // Data rows
    data.forEach(dataObj => {
      const row = columnConfigs.map(({ getter }) => {
        try {
          return getter(dataObj);
        } catch (e) {
          return '';
        }
      });
      ws.addRow(row);
    });
  });

  const buf = await wb.xlsx.writeBuffer();
  saveAs(
    new Blob([buf], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    `${filename}.xlsx`
  );
};
